function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-lightning_svg__a",
  d: "M0 0h100v100H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "icon-lightning_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-lightning_svg__a",
  overflow: "visible"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.8 47.86c0-14.2-11.56-25.71-25.8-25.71-14.25 0-25.8 11.51-25.8 25.71 0 11.97 8.23 22.01 19.35 24.87v5.13h12.9v-5.13c11.12-2.86 19.35-12.9 19.35-24.87h0zM52.15 95h-4.3 4.3zm4.3-8.57h-12.9 12.9zM50 5v8.57V5h0zm43 42.86h-8.6H93zm-86 0h8.6H7h0zm9.55-33.34l9.12 9.09-9.12-9.09h0zm66.89 0l-9.12 9.09 9.12-9.09h0z",
  clipPath: "url(#icon-lightning_svg__b)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgIconLightning(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CgkKCQkuc3Qwe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8Zz4KCQk8ZGVmcz4KCQkJPHJlY3QgaWQ9IlNWR0lEXzFfIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIvPgoJCTwvZGVmcz4KCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4KCQkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQk8L2NsaXBQYXRoPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik03NS44LDQ3Ljg2YzAtMTQuMi0xMS41Ni0yNS43MS0yNS44LTI1LjcxYy0xNC4yNSwwLTI1LjgsMTEuNTEtMjUuOCwyNS43MWMwLDExLjk3LDguMjMsMjIuMDEsMTkuMzUsMjQuODcKCQkJdjUuMTNoMTIuOXYtNS4xM0M2Ny41Nyw2OS44Nyw3NS44LDU5LjgzLDc1LjgsNDcuODZMNzUuOCw0Ny44NnogTTUyLjE1LDk1aC00LjNINTIuMTVMNTIuMTUsOTV6IE01Ni40NSw4Ni40M2gtMTIuOUg1Ni40NQoJCQlMNTYuNDUsODYuNDN6IE01MCw1djguNTdWNUw1MCw1eiBNOTMsNDcuODZoLTguNkg5M0w5Myw0Ny44NnogTTcsNDcuODZoOC42SDdMNyw0Ny44NnogTTE2LjU1LDE0LjUybDkuMTIsOS4wOUwxNi41NSwxNC41MgoJCQlMMTYuNTUsMTQuNTJ6IE04My40NCwxNC41MmwtOS4xMiw5LjA5TDgzLjQ0LDE0LjUyTDgzLjQ0LDE0LjUyeiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { SvgIconLightning as ReactComponent };